var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-customer-manage',{ref:"table",staticClass:"pt-customer-manage__withData",on:{"deleteCustomer":_vm.deleteCustomer}})}
var staticRenderFns = []

export { render, staticRenderFns }